module.exports = {
	/* 大厅微应用配置 start */
	HALL_APP_NAME: require('../packages/gx-hall/package.json').name,
	HALL_PRO_PUBLIC_PATH: '/child/micro-hall/',
	HALL_DEV_PUBLIC_PATH: '/hall/',
	HALL_ACTIVE_RULE: '/hall',
	HALL_DEV_PORT: '9102',
	/* 大厅微应用配置 end */
	/* 消防管理端微应用配置 start */
	MANAGER_APP_NAME: 'gx-micro',
	MANAGER_PRO_PUBLIC_PATH: '/child/micro-fire/',
	MANAGER_DEV_PUBLIC_PATH: '/fire/',
	MANAGER_ACTIVE_RULE: '/fire',
	MANAGER_DEV_PORT: '9101',
	/* 消防管理端微应用配置 end */
	/* 消防系统管理微应用配置 start */
	SYSTEM_APP_NAME: 'micro-system',
	SYSTEM_PRO_PUBLIC_PATH: '/child/micro-system/',
	SYSTEM_DEV_PUBLIC_PATH: '/system/',
	SYSTEM_ACTIVE_RULE: '/system',
	SYSTEM_DEV_PORT: '9103',
	/* 消防系统管理微应用配置 end */
	/* 专家库微应用配置 start */
	EXPERT_APP_NAME: 'micro-expert',
	EXPERT_PRO_PUBLIC_PATH: '/child/micro-expert/',
	EXPERT_DEV_PUBLIC_PATH: '/expert/',
	EXPERT_ACTIVE_RULE: '/expert',
	EXPERT_DEV_PORT: '9104',
	/* 专家库微应用配置 end */
	/* 大屏微应用配置 start */
	BIGSCREEN_APP_NAME: 'micro-sas',
	BIGSCREEN_PRO_PUBLIC_PATH: '/child/sas/',
	BIGSCREEN_DEV_PUBLIC_PATH: '/sas/',
	BIGSCREEN_ACTIVE_RULE: '/sas',
	BIGSCREEN_DEV_PORT: '9106',
	/* 大屏微应用配置 end */
	/* 统计报表微应用配置 start */
	REPORT_APP_NAME: '@rjgf/report-ui',
	REPORT_PRO_PUBLIC_PATH: '/child/report-ui/',
	REPORT_DEV_PUBLIC_PATH: '/report-ui/',
	REPORT_ACTIVE_RULE: '/report-ui',
	REPORT_DEV_PORT: '9528',
	/* 统计报表微应用配置 end */
}
